"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexColor = exports.HexRgba = exports.HexRgb = void 0;
const effect_1 = require("effect");
const makeHexStringArb = (numBytes) => (FC) => FC.uint8Array({ minLength: numBytes, maxLength: numBytes }).map(arr => '#' + effect_1.Encoding.encodeHex(arr), str => {
    if (typeof str !== 'string')
        return new Uint8Array(numBytes);
    const encoded = effect_1.Encoding.decodeHex(str.slice(1));
    if (effect_1.Either.isLeft(encoded))
        return new Uint8Array(numBytes);
    return encoded.right;
});
exports.HexRgb = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^#([a-fA-F0-9]{2}){3}$/)).annotations({
    identifier: 'Color.HexRgb',
    description: 'A # followed by exactly 6 hexadecimal digits (case-agnostic)',
    arbitrary: () => makeHexStringArb(3),
});
exports.HexRgba = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^#([a-fA-F0-9]{2}){4}$/)).annotations({
    identifier: 'Color.HexRgba',
    description: 'A # followed by 8 exactly hexidecimal digits (case-agnostic)',
    arbitrary: () => makeHexStringArb(4),
});
exports.HexColor = effect_1.Schema.Union(exports.HexRgb, exports.HexRgba).annotations({
    identifier: 'Color.HexColor',
    description: 'A hex RGB or hex RGBA string',
});
//# sourceMappingURL=color.js.map